import { createTheme } from '@vanilla-extract/css'

export const rawColors = {
  primary: '#FC6A6A',
  primaryAlt: '#D65555',
  primaryFaded: '#FFEBEE',
  dark: '#093546',
  darkLighter: '#0F5570',
  white: '#ffffff',
  mainHover: '#E3EAEC',
  inactive: '#D0DADD',
  medium: '#A7BFC7',
  mediumLighter: '#E3EAEC',
  mediumDarker: '#869CA3',
  drawBackground: '#F9F1ED',
  drawBackgroundLighter: '#F5F8F9',
  light: '#F5F8F9',
  success: '#15C590',
  successLighter: '#E8F5F1',
  warning: '#F1B315',
  warningLight: '#F5D377',
  warningLighter: '#F5E4B6',
  warningBackground: '#FDFAF0',
  danger: '#EC3D55',
  dangerLighter: '#FFDADF',
  notification: '#FCF0D0',
  ai: '#6184FF'
}

export const [themeClass, vars] = createTheme({
  color: rawColors,
  shadow: '0px 5px 18px rgba(9, 53, 70, 0.08)',
  shadowLight: '0px 1px 8px 0px rgba(0, 0, 0, 0.07)',
  shadowRegular: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  shadowPrimary: '0px 1px 8px 0px rgba(252, 106, 106, 0.5)',
  layout: {
    headerHeight: '60px'
  },
  buttons: {
    radius: '8px'
  },
  blocks: {
    smallRadius: '8px',
    radius: '10px',
    largeRadius: '22px',
    veryLargeRadius: '39px',
    modale: {
      padding: '20px 23px',
      background: '#ffffff',
      shadow: '0px 5px 18px rgba(9, 53, 70, 0.08)'
    }
  },
  paper: {
    padding: '25px',
    background: '#ffffff',
    radius: '17px',
    border: '1px solid #E2E2E2'
  },
  font: {
    headerTitle: {
      size: '24px',
      weight: '700'
    },
    title: {
      size: '20px',
      weight: '600'
    },
    pageTitle: {
      size: '24px',
      weight: '700'
    },
    label: {
      size: '16px',
      weight: '600'
    },
    input: {
      size: '16px',
      weight: '500',
      icon: '13px',
      borderColor: 'rgba(15, 85, 112, 0.5)'
    },
    content: {
      size: '16px',
      weight: '500',
      borderColor: '#E3E3E3'
    },
    subcontent: {
      size: '14px',
      weight: '500'
    },
    tableContent: {
      size: '14px',
      weight: '400'
    },
    h1: {
      size: '28px',
      weight: '700'
    },
    h2: {
      size: '24px',
      weight: '700'
    },
    h3: {
      size: '20px',
      weight: '700'
    },
    h4: {
      size: '18px',
      weight: '700'
    },
    h5: {
      size: '16px',
      weight: '600'
    },
    smallNormal: {
      size: '12px',
      weight: '500'
    },
    smallBold: {
      size: '12px',
      weight: '700'
    },
    body: {
      size: '16px',
      weight: '500'
    },
    bodyBold: {
      size: '16px',
      weight: '700'
    }
  }
})
